import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { ToolbarButton } from "./../../_shared/toolbar-button/toolbar-button.js";
const RemoveLinkButton = ({ toolbarItem }) => {
  const { t } = useContext(RicosContext);
  const tooltip = t(toolbarItem.presentation?.tooltip);
  const dataHook = toolbarItem.presentation?.dataHook;
  return /* @__PURE__ */ React.createElement(
    ToolbarButton,
    {
      tooltip,
      onClick: () => {
        toolbarItem.commands.click();
      },
      prefix: toolbarItem.presentation?.icon,
      dataHook,
      tabIndex: toolbarItem.presentation.tabIndex
    }
  );
};
export {
  RemoveLinkButton
};
//# sourceMappingURL=remove-link-button.js.map
